import { ThemeToggle } from '../ui/ThemeToggle';

interface HeaderProps {
  taxYearDisplayName?: string;
  activeTab: 'calculator' | 'education';
  onTabChange: (tab: 'calculator' | 'education') => void;
}

export function Header({ taxYearDisplayName, activeTab, onTabChange }: HeaderProps) {
  const tabs = [
    { id: 'calculator' as const, name: 'Tax Calculator' },
    { id: 'education' as const, name: 'Tax Education' }
  ];

  return (
    <header className="bg-white dark:bg-slate-900 shadow-sm border-b border-gray-200 dark:border-slate-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          {/* Logo Section */}
          <div className="flex items-center gap-4 flex-1">
            <img 
              src="/logo-full.png" 
              alt="reverseTax - SA Reverse Tax Calculator" 
              className="h-10 w-auto"
            />
            {taxYearDisplayName && (
              <div className="hidden lg:block">
                <p className="text-gray-600 dark:text-slate-400 text-sm">
                  SARS tax brackets for {taxYearDisplayName}
                </p>
              </div>
            )}
          </div>
          
          {/* Right side: Tabs + Theme Toggle */}
          <div className="flex items-center gap-3">
            <nav className="flex space-x-1 bg-gray-100 dark:bg-slate-800 rounded-lg p-1" role="navigation" aria-label="Main navigation">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => onTabChange(tab.id)}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                    activeTab === tab.id
                      ? 'bg-white dark:bg-slate-700 text-sa-green shadow-sm'
                      : 'text-gray-600 dark:text-slate-400 hover:text-charcoal dark:hover:text-slate-200'
                  }`}
                  aria-pressed={activeTab === tab.id}
                >
                  {tab.name}
                </button>
              ))}
            </nav>
            
            <ThemeToggle />
          </div>
        </div>
      </div>
    </header>
  );
}
